import * as React from 'preact/compat'
import { SeriesSchemeState } from './state'
import styles from '../../../css/game-series-scheme.pcss.json'
import { Portal } from '../Modal'
import cn from 'classnames'
import alertCss from '../../../css/sg-alert.pcss.json'
import { useEffect } from 'preact/compat'

export default ({ id }: { id: number }) => {
  const context = React.useContext(SeriesSchemeState)
  const gameInfo = context.games.value.find(game => game.id === id)

  let developers: string | React.JSX.Element = 'Не указан'
  if (gameInfo.developers.length > 0) {
    developers = gameInfo.developers
      .map(developer => <a href={`/company/${developer.comp_id}`}>{developer.comp_name}</a>)
      // @ts-ignore
      .reduce((accu, curr) => accu === null ? [curr] : [...accu, ', ', curr], null)
  }
  let platforms: string | React.JSX.Element = 'Не указаны'
  const realPlatforms = gameInfo.platforms.filter(platform => !!platform)
  if (realPlatforms.length > 0) {
    platforms = realPlatforms.map(platform => <a
      href={`/games/${platform.code.replaceAll(' ', '_')}`}
      title={platform.title}
    >{platform.code}</a>)
      // @ts-ignore
      .reduce((accu, curr) => accu === null ? [curr] : [...accu, ' | ', curr], null)
  }

  gameInfo.genres = gameInfo.genres.filter(genre => !!genre)

  const children = <>
    <a href={gameInfo.link} className={styles['info-panel__title']}>{gameInfo.title}</a>
    <div className={styles['info-panel__info-grid']}>
      <span className={styles['info-panel__info-grid__title']}>Дата выхода</span>
      <span>{gameInfo.releaseDate}</span>
      <span className={styles['info-panel__info-grid__title']}>Разработчик</span>
      {/* @ts-ignore */}
      <span>{developers}</span>
      <span className={styles['info-panel__info-grid__title']}>Платформы</span>
      {/* @ts-ignore */}
      <span>{platforms}</span>
    </div>
    {gameInfo.genres.length > 0 &&
      <div className={styles['info-panel__genres-container']}>
        {gameInfo.genres.map(genre => <div className={styles['info-panel__genre']}>{genre.name_singular}</div>)}
      </div>
    }
  </>

  if (context.isMobile.value) {
    const overlayClick = () => {
      context.infoPanelGame.value = null
    }

    const preventBubbling = (e: MouseEvent) => {
      e.stopPropagation()
    }

    const [shown, setShown] = React.useState<boolean>(true)
    const portal = React.useRef<Portal>()

    useEffect(() => {
      setTimeout(() => {
        if (portal.current) {
          setShown(true)
        }
      }, 300)
    }, [])

    return <Portal portalId={`modal-portal-game-info`} ref={portal}>
      <div
        className={cn(alertCss['overlay'], {
          [alertCss['overlay--in']]: shown,
        })} onClick={overlayClick}
      >
        <div
          className={cn({
            [alertCss['modal']]: true,
            [alertCss['modal--in']]: shown,
          })}
          onClick={preventBubbling}
          style='display: flex; flex-direction: column; padding: 16px 32px; row-gap: 24px; align-items: start'
        >
          {children}
        </div>
      </div>
    </Portal>
  }
  return <div className={styles['info-panel']}>
    {children}
  </div>
}
